<template>
  <div>
    <navbar></navbar>


    <b-button @click="print" variant="danger">{{ $t('printTitle') }}</b-button>

    <b-card title="Filter">
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="date from">
            <date-picker
                format="YYYY-MM-DD"
                display-format="YYYY-MM-DD"
                locale="en" v-model="form.dateFrom"></date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="date to">
            <date-picker
                format="YYYY-MM-DD"
                display-format="YYYY-MM-DD"
                locale="en" v-model="form.dateTo"></date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="time">
            <b-form-select :options="months" @change="formatDateType" v-model="form.dateType"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="payments">
            <v-select
                class="mb-4"
                placeholder="select payments"
                multiple
                :reduce="text => text.value"
                label="text"
                v-model="form.filterType"
                :options="payments"></v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Countries">
            <v-select
                class="mb-4"
                @input="onSelectCountry"
                placeholder="select countries"
                multiple
                :reduce="text => text.city_id"
                label="city_name"
                v-model="form.selectedCountry"
                :options="countries"></v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Überweisung">
            <b-form-checkbox v-model="form.isAdminOrders">Überweisung</b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-button @click="getReports" variant="info">search</b-button>
        </b-col>

        <b-col cols="12" md="6">
          <template v-if="form.dateFrom !== null && form.dateTo !== null">
            <b-link class="text-danger mr-4" @click="removeDates">remove dates</b-link>
          </template>
          <template v-if="form.dateType !== null">
            <b-link class="text-danger" @click="removeFilterTime">remove time</b-link>
          </template>
        </b-col>
      </b-row>
    </b-card>
    <!--END Filter-->

    <b-card id="printMe">
      <h3 class="my-0 text-center font-weight-bold">
        Buchhaltung Lord of Hanf e.U.
      </h3>
      <div class="mt-3">

        <template v-if="selectedCountryName.length">
          <p>
            <span class="mr-3" v-for="(index) in selectedCountryName"
                  :key="index">{{ index }}</span>
          </p>

        </template>
        <template v-if="form.filterType.length">
                                            <span class="mr-3" v-for="(index) in form.filterType"
                                                  :key="index">{{ index }}</span>
        </template>

        <template v-if="form.isAdminOrders">
          <span class="mr-3">Überweisung</span>
        </template>

      </div>
      <div class="mt-3" v-if="form.dateType">
        <span>{{ dateTypeFormat }}</span>
      </div>
      <div class="mt-3" v-if="form.dateFrom !== null && form.dateTo !== null">
        <span>{{ dateFrom }}</span>
        <span class="mx-3">-</span>
        <span>{{ dateTo }}</span>
      </div>

      <br>


      <div class="table-responsive">

        <table class="table">
          <thead class="thead-light">
          <tr>
            <th style="width: 3%">Best.</th>
            <th>{{ $t('dateTitle') }}</th>
            <th>Titel</th>
            <th>Best.-Nr.</th>
            <th style="width: 10%">Zahl. Mögl.</th>
            <th>Zahlung</th>
            <th>Netto</th>
            <th>Mwst</th>
            <th>Brutto</th>
          </tr>
          </thead>

          <tbody class="list">
          <tr v-for="(row,index) in items" :key="index">
            <td>{{ ++index }}</td>
            <td>
              {{ row.date }}
            </td>
            <td>
              {{ row.title }}
            </td>
            <td>
              {{ row.tracking_number }}
            </td>
            <td>
              <template v-if="row.isAdmin === 'yes'">
                Überweisung
              </template>
              <template v-else>
                {{ row.payment_type }}
              </template>
            </td>
            <td>
              {{ row.payment_status }}
            </td>
            <td>
              {{ row.totalSubtract }} €
            </td>
            <td>
              {{ row.totalTax }} €
            </td>
            <td>
              {{ row.totalPrice }} €
            </td>
          </tr>
          </tbody>


          <tr style="border-top: 3px solid #000">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td><strong class="font-weight-bold">Gesamtsumme</strong></td>
            <td>
              <strong class="font-weight-bold">{{ totalPriceSubtract }} €</strong>
            </td>
            <td>
              <strong class="font-weight-bold">{{ totalPriceTax }} €</strong>
            </td>
            <td>
              <strong class="font-weight-bold">{{ totalPrice }} €</strong>
            </td>
          </tr>
        </table>

      </div>

    </b-card>
  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notificaion from '../../Services/Notification/Nottification'
import 'vue-select/dist/vue-select.css';

export default {
  name: "Index",
  components: {Navbar},
  data() {
    return {
      dateFrom: null,
      dateTo: null,
      dateTypeFormat: null,
      totalPrice: 0,
      totalPriceTax: 0,
      totalPriceSubtract: 0,
      countries:[],
      selectedCountryName:[],
      form: {
        dateFrom: null,
        dateTo: null,
        dateType: null,
        isAdminOrders: false,
        filterType: [],
        selectedCountry: [],
      },
      months: [
        {
          text: 'Jahresabrechnung',
          value: 'year'
        },
        {
          text: 'Monatsabrechnung',
          value: 'month'
        },
        {
          text: 'Wochenabrechnung',
          value: '7days'
        },

      ],
      payments: [
        {
          text: "card",
          value: "card"
        },
        {
          text: "eps",
          value: "eps"
        },
        {
          text: "vorkasse",
          value: "vorkasse"
        },
        {
          text: "nachname",
          value: "nachname"
        },
        {
          text: "Barzahlung bei Abholung",
          value: "inperson"
        },
        {
          text: "EC Karte bezahlt",
          value: "posdevice"
        },
        {
          text: "Kauf auf Rechnung",
          value: "purhcaseoninvoice"
        },
      ]
    }
  },
  methods: {
    onSelectCountry(countryVal){
      this.selectedCountryName=[];
      countryVal.forEach(countryItem=>{
        this.countries.forEach(country=>{
          if (country.city_id === countryItem){
            this.selectedCountryName.push(country.city_name)
          }
        })

      })
    },
    removeFilterTime() {
      this.form.dateType = null;
      this.getReports();
    },
    formatDateType() {
      switch (this.form.dateType) {
        case "year":
          this.dateTypeFormat = "Jahresabrechnung";
          break;
        case "month":
          this.dateTypeFormat = "Monatsabrechnung";
          break;
        case "7days":
          this.dateTypeFormat = "Wochenabrechnung";
          break;
      }
    },
    removeDates() {
      this.form.dateFrom = null;
      this.form.dateTo = null;
      this.getReports();
    },
    print() {
      this.$htmlToPaper('printMe');
    },
    getCountries() {
      //this.$Progress.start();
      Http.get(Http.apiurl() + 'country/index')
          .then(response => {
            //this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.countries = response.data.data;
            } else {
              Notificaion.error(response.data.message)
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    getReports() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'finance/index', this.form)
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              this.$Progress.finish();
              this.items = response.data.data.items;
              this.totalPrice = response.data.data.totalPrice;
              this.totalPriceTax = response.data.data.totalPriceTax;
              this.totalPriceSubtract = response.data.data.totalPriceSubtract;
              this.dateFrom = response.data.data.dateFrom;
              this.dateTo = response.data.data.dateTo;
            } else {
              Notificaion.error(response.data.message)
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
  },
  created() {
    this.getReports();
    this.getCountries();
  }
}
</script>

<style scoped>
table td {
  padding: 0 0;
  white-space: nowrap;
  font-size: 13px;
}
</style>